import styled from "styled-components";

export const ThreeColumns = styled.div`
  &&& {
    position: relative;
    font-size: 12px;
    margin: 0 20px;
    margin-top: -10px;

    @media print {
      margin-top: -15px;
    }
  }
`;

export const GraphSide = styled.div`
  &&& {
    & > div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &.portrait.left-side,
    &.portrait.right-side {
      width: 25%;
      position: absolute;
    }

    &.portrait.left-side {
      text-align: right;
      bottom: 53px;
      left: 0;

      &.pulse {
        width: 22%;

        .header {
          font-size: 14px;
        }
      }
    }

    &.portrait.right-side {
      top: 52px;
      right: 0;
    }

    &.below {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      max-height: 200px;
      flex-wrap: wrap;
    }

    &.below.left-side {
      margin-right: 8px;
    }

    &.below.right-side {
      margin-left: 8px;
    }
  }
`;

export const GraphSideText = styled.p`
  &&& {
    margin: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 220px;

    &.header {
      font-size: 18px;
      text-transform: uppercase;
    }

    &.excellence,
    &.opportunity {
      font-size: 15px;
      min-width: 160px;
    }

    &.excellence {
      color: #55c141;
    }

    &.opportunity {
      color: #c33d3d;
    }

    &.portait {
      margin-top: 2px;
    }
  }
`;

export const GraphLayout = styled.div`
  &&& {
    width: 417px;
    position: relative;
    font-size: 20px;

    &.portrait {
      width: 53%;
      margin-left: 25%;
    }
  }
`;

export const LayoutContent = styled.div`
  &&& {
    padding-top: 40px;
    margin: 0 40px;
    position: relative;
  }
`;

export const XAxisLabel = styled.p`
  &&& {
    text-align: center;
    letter-spacing: 1px;
    line-height: 40px;
    margin: 0;
    height: 40px;
    &.question {
      font-size: 14px;
      line-height: 16px;
      margin: 4px -10px 0;
    }
  }
`;

export const YAxisLabel = styled.p`
  &&& {
    text-align: center;
    letter-spacing: 1px;
    line-height: 40px;
    width: 500px;
    white-space: nowrap;
    transform: rotate(-90deg);
    position: absolute;
    top: 46%;
    left: -230px;
    margin: 0;
    &.question {
      top: 157px;
      left: -177px;
      font-size: 14px;
      line-height: 16px;
      height: 100px;
      width: 316px;
      white-space: normal;
      @media print {
        top: -11px;
        left: -167px;
      }

      span {
        display: table-cell;
        vertical-align: bottom;
        height: 100px;
        @media print {
          transform: rotate(90deg);
        }
      }
    }
  }
`;

export const GraphBackground = styled.div`
  &&& {
    width: 303px;
    height: 303px;
    margin: 17px;
    overflow: hidden;
    background: #ffeac5;
    position: relative;
  }
`;

export const RedBox = styled.div`
  &&& {
    width: 58%;
    height: 58%;
    position: absolute;
    bottom: 0;
    left: 0;
    box-shadow: 0 0 14px 8px #ff9595;
    background: #ff9595;
    opacity: 0.6;

    @media print {
      box-shadow: none;
      width: 60%;
      height: 60%;
    }
  }
`;

export const YellowGreenBox = styled.div`
  &&& {
    width: 28%;
    height: 28%;
    position: absolute;
    top: 0;
    right: 0;
    box-shadow: 0 0 14px 8px #cae0a3;
    background: #cae0a3;

    @media print {
      box-shadow: none;
      width: 30%;
      height: 30%;
    }
  }
`;

export const GreenBox = styled.div`
  &&& {
    width: 18%;
    height: 18%;
    position: absolute;
    top: 0;
    right: 0;
    box-shadow: 0 0 14px 8px #77dc65;
    background: #77dc65;

    @media print {
      box-shadow: none;
      width: 20%;
      height: 20%;
    }
  }
`;

export const Graph = styled.div`
  &&& {
    display: table;

    :before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    svg {
      overflow: visible;
      position: absolute;
      top: 40px;
      left: 0;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        transform: translateY(-80px);
      }
    }

    .nv-point-paths {
      display: none !important;
    }

    .nv-point {
      font-size: 22px !important;
      fill: #000;
      fill-opacity: 1;
    }

    .nv-group {
      stroke: #5c6369 !important;
    }
  }
`;

export const Dot = styled.div`
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.5);
  width: 16px;
  height: 16px;
  position: absolute;
`;

export const InfoBelowGraph = styled.div`
  display: flex;
  padding-top: 10px;
  margin: 0 -60px;
`;

export const Landscape = styled.div`
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/ScatterPlot/style.js